__turbopack_context__.v({
  "benefitGrid": "benefitSection-module-scss-module__l2ql3W__benefitGrid",
  "benefitGridItem": "benefitSection-module-scss-module__l2ql3W__benefitGridItem",
  "benefitIconContent": "benefitSection-module-scss-module__l2ql3W__benefitIconContent",
  "benefitIconContent-center": "benefitSection-module-scss-module__l2ql3W__benefitIconContent-center",
  "benefitIconContent-left": "benefitSection-module-scss-module__l2ql3W__benefitIconContent-left",
  "benefitImageStyleCenter": "benefitSection-module-scss-module__l2ql3W__benefitImageStyleCenter",
  "benefitItem": "benefitSection-module-scss-module__l2ql3W__benefitItem",
  "benefitItem-center": "benefitSection-module-scss-module__l2ql3W__benefitItem-center",
  "benefitItem-left": "benefitSection-module-scss-module__l2ql3W__benefitItem-left",
  "benefitItemContent": "benefitSection-module-scss-module__l2ql3W__benefitItemContent",
  "benefitItemContentListStyleCenter": "benefitSection-module-scss-module__l2ql3W__benefitItemContentListStyleCenter",
  "benefitItemContentListStyleLeft": "benefitSection-module-scss-module__l2ql3W__benefitItemContentListStyleLeft",
  "benefitItemContentProducts": "benefitSection-module-scss-module__l2ql3W__benefitItemContentProducts",
  "benefitItemImg": "benefitSection-module-scss-module__l2ql3W__benefitItemImg",
  "benefitItemImgFullWidth": "benefitSection-module-scss-module__l2ql3W__benefitItemImgFullWidth",
  "benefitItemProductList1": "benefitSection-module-scss-module__l2ql3W__benefitItemProductList1",
  "benefitItemProucts": "benefitSection-module-scss-module__l2ql3W__benefitItemProucts",
  "benefitItemText": "benefitSection-module-scss-module__l2ql3W__benefitItemText",
  "benefitItemTitle": "benefitSection-module-scss-module__l2ql3W__benefitItemTitle",
  "benefitItemTitleProducts": "benefitSection-module-scss-module__l2ql3W__benefitItemTitleProducts",
  "benefitPadding": "benefitSection-module-scss-module__l2ql3W__benefitPadding",
  "benefitSection": "benefitSection-module-scss-module__l2ql3W__benefitSection",
  "benefitSectionProducts": "benefitSection-module-scss-module__l2ql3W__benefitSectionProducts",
  "benefitTitleContent": "benefitSection-module-scss-module__l2ql3W__benefitTitleContent",
  "benefitTitleContent-center": "benefitSection-module-scss-module__l2ql3W__benefitTitleContent-center",
  "benefitTitleContent-left": "benefitSection-module-scss-module__l2ql3W__benefitTitleContent-left",
  "carouselHiddenOnDesktop": "benefitSection-module-scss-module__l2ql3W__carouselHiddenOnDesktop",
  "cta": "benefitSection-module-scss-module__l2ql3W__cta",
  "cta-left": "benefitSection-module-scss-module__l2ql3W__cta-left",
  "ctaContainer": "benefitSection-module-scss-module__l2ql3W__ctaContainer",
  "ctaContainer-left": "benefitSection-module-scss-module__l2ql3W__ctaContainer-left",
  "ctaContainerButton": "benefitSection-module-scss-module__l2ql3W__ctaContainerButton",
  "ctaSecond": "benefitSection-module-scss-module__l2ql3W__ctaSecond",
  "ctaSubContainer": "benefitSection-module-scss-module__l2ql3W__ctaSubContainer",
  "darkTheme": "benefitSection-module-scss-module__l2ql3W__darkTheme",
  "descBottom": "benefitSection-module-scss-module__l2ql3W__descBottom",
  "descSection": "benefitSection-module-scss-module__l2ql3W__descSection",
  "description": "benefitSection-module-scss-module__l2ql3W__description",
  "descriptionProducts": "benefitSection-module-scss-module__l2ql3W__descriptionProducts",
  "eggshell": "benefitSection-module-scss-module__l2ql3W__eggshell",
  "fullwidth": "benefitSection-module-scss-module__l2ql3W__fullwidth",
  "grid2x2Plus1": "benefitSection-module-scss-module__l2ql3W__grid2x2Plus1",
  "gridHiddenOnMobile": "benefitSection-module-scss-module__l2ql3W__gridHiddenOnMobile",
  "icon": "benefitSection-module-scss-module__l2ql3W__icon",
  "illustration": "benefitSection-module-scss-module__l2ql3W__illustration",
  "imageContain": "benefitSection-module-scss-module__l2ql3W__imageContain",
  "infoSection": "benefitSection-module-scss-module__l2ql3W__infoSection",
  "infoText": "benefitSection-module-scss-module__l2ql3W__infoText",
  "leftCheckIcon": "benefitSection-module-scss-module__l2ql3W__leftCheckIcon",
  "linkTitle": "benefitSection-module-scss-module__l2ql3W__linkTitle",
  "mainContainer": "benefitSection-module-scss-module__l2ql3W__mainContainer",
  "mobileCarousel": "benefitSection-module-scss-module__l2ql3W__mobileCarousel",
  "productsModule": "benefitSection-module-scss-module__l2ql3W__productsModule",
  "sectionGrid2x2Plus1": "benefitSection-module-scss-module__l2ql3W__sectionGrid2x2Plus1",
  "text": "benefitSection-module-scss-module__l2ql3W__text",
  "thumbnail": "benefitSection-module-scss-module__l2ql3W__thumbnail",
  "thumbnailImage": "benefitSection-module-scss-module__l2ql3W__thumbnailImage",
  "title": "benefitSection-module-scss-module__l2ql3W__title",
  "titleContainer": "benefitSection-module-scss-module__l2ql3W__titleContainer",
  "titleProducts": "benefitSection-module-scss-module__l2ql3W__titleProducts",
  "transparent": "benefitSection-module-scss-module__l2ql3W__transparent",
  "whiteTheme": "benefitSection-module-scss-module__l2ql3W__whiteTheme",
});
